import { CheckCircleIcon } from "@chakra-ui/icons";
import {
  Box,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

import Button from "../Button/Button";

const SuccessModal = ({ isOpen, onClose, message, title, children }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        maxW={300}
        bg="#03A438"
        isCentered
        fontFamily="var(--poppins)"
        borderRadius="24px"
      >
        <ModalBody>
          <Box as={VStack} pt="20px" color="white" textAlign="center">
            <CheckCircleIcon fontSize="100px" mb="20px" />
            <Heading
              fontSize="xl"
              fontWeight="500"
              fontFamily="var(--poppins)"
              letterSpacing="-1px"
            >
              {title}
            </Heading>
            {!children && (
              <Text m="0" fontFamily="var(--poppins)" letterSpacing="-1px">
                {message}
              </Text>
            )}

            {children && children}
          </Box>
        </ModalBody>

        <ModalFooter as={HStack} justify="flex-end">
          <Button
            onClick={onClose}
            minW="60px"
            size="sm"
            color="white"
            variant="ghost"
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
